import { Listener } from '../wsServices/Stream';
import { IWsSpecificNetworkService } from './WsSpecificNetworkService.types';

export class WsEventsManager {
  constructor(private networkService: IWsSpecificNetworkService) {}

  on<EventResponse>(eventName: string, listener: Listener<EventResponse>): () => void {
    return this.networkService.onEvent(eventName, listener);
  }
}
